<template>
  <div class="mx-5 mt-3 text-left">
    <p>
      ASCA has adopted and is using the trademarks: ASCA®, Australian Shepherd
      Club of America, Aussie Times, and the Australian Shepherd Dog Bust Logo.
      Licensee acknowledges the validity of ASCA's title to these marks and
      agrees not to contest such title.
    </p>
    <p>
      In consideration of the mutual promises contained in this license, ASCA
      grants to Licensee a non-exclusive, revocable right the use the mark(s)
      checked above solely in conjunction with:
    </p>
    <ul>
      <li>ASCA Sanctioned Events Judge's Gift</li>
      <li>ASCA Sanctioned Event Ribbons/Awards</li>
      <li>ASCA Affiliate Club Equipment</li>
    </ul>
    <br />
    <p>
      ASCA may revoke this license at any time in its absolute and sole
      discretion. Unless revoked, this license remains in effect on annual
      affiliate renewals.
    </p>
    <p>
      Licensee shall use the mark(s) only in connection with goods and services
      which meet the standards, specification and quantities established by
      ASCA. Licensee shall submit each use of the mark(s) for approval by ASCA
      before initiating such use. ASCA has the right, at all reasonable times,
      to inspect Licensee's goods and services employing the mark(s) to
      determine they are of a quality acceptable to ASCA.
    </p>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  name: "AffiliateSignatureText",
});
</script>